// Generated file : do not modify
import Subscription from '@/extend/classes/Subscription';
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { PaymentMeansTypes } from '@/generated/classes/PaymentMeans';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Paniers
export class CartItem {
  // Type d'objet'
  public objType: ObjTypes;
  // ID de l'objet
  public objId: number;
  // Payé immédiatement
  public auto: boolean;
  // Report du montant minimal de règlement
  public isMinimumPaymentCarry: boolean;
  // Selectionné pour paiement
  public selected: boolean;
  // Libellé
  public label: string;
  // Référence
  public reference: string;
  // Projet
  public projet: string;
  // Date
  public date: Date;
  // Selectionné pour paiement
  public selectedHt: number;
  // Selectionné pour paiement
  public selectedTva: number;
  // Selectionné pour paiement
  public selectedTtc: number;

  constructor() {
    this.objType = ObjTypes.NONE;
    this.objId = 0;
    this.auto = false;
    this.isMinimumPaymentCarry = false;
    this.selected = false;
    this.label = '';
    this.reference = '';
    this.projet = '';
    this.date = new Date(1901,1,1,0,0,0,0);
    this.selectedHt = 0;
    this.selectedTva = 0;
    this.selectedTtc = 0;
  }
}

export default class Cart  {
  // Identifiant du titulaire
  public id: number;
  // Confirmation de règlement
  public commandId: string;
  // Référence du règlement
  public paymentReference: string;
  // Abonnement commandé
  public subscription: Subscription | null;
  // Liste des items du pannier
  public cartItems: CartItem[];
  // Somme à régler
  public selectedTtc: number;
  // Somme à régler
  public selectedLetterTtc: string;
  // Item en attente de validation support
  public hasWaitingItems: boolean;
  // Titulaire
  public owner: Owner;
  // Type du titulaire
  public ownerType: number;
  // Identifiant du titulaire
  public ownerId: number;
  // Nom du titulaire
  public ownerLabel: string;
  // Vérifie l'opération si total négatif
  public verify: boolean;
  // Utilisé pour le règlement d'une paie
  public fromPaie: boolean;
  // Type de paiement
  public paymentMeansType: PaymentMeansTypes;
  // Moyen de paiement
  public paymentMeansId: number;
  // Montant minimal d'un règlement
  public minimumPaymentAmount: number;
  // Ferme le dialog
  public closeDialog: boolean;
  // Minimum d'un remboursement
  public minRepay: number;

  constructor() {
    this.id = 0;
    this.commandId = '';
    this.paymentReference = '';
    this.subscription = null;
    this.cartItems = [];
    this.selectedTtc = 0;
    this.selectedLetterTtc = '';
    this.hasWaitingItems = false;
    this.owner = new Owner();
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
    this.verify = false;
    this.fromPaie = false;
    this.paymentMeansType = PaymentMeansTypes.NONE;
    this.paymentMeansId = 0;
    this.minimumPaymentAmount = 0;
    this.closeDialog = false;
    this.minRepay = 0;
  }

  public static fromJson (obj: Cart): Cart {
    const newCart: Cart = new Cart();
    newCart.id = obj.id;
    newCart.commandId = obj.commandId;
    newCart.paymentReference = obj.paymentReference;
    newCart.subscription = JSON.parse(JSON.stringify(obj.subscription));
    newCart.cartItems = JSON.parse(JSON.stringify(obj.cartItems));
    newCart.selectedTtc = obj.selectedTtc;
    newCart.selectedLetterTtc = obj.selectedLetterTtc;
    newCart.hasWaitingItems = obj.hasWaitingItems;
    newCart.owner = JSON.parse(JSON.stringify(obj.owner));
    newCart.ownerType = obj.ownerType;
    newCart.ownerId = obj.ownerId;
    newCart.ownerLabel = obj.ownerLabel;
    newCart.verify = obj.verify;
    newCart.fromPaie = obj.fromPaie;
    newCart.paymentMeansType = obj.paymentMeansType;
    newCart.paymentMeansId = obj.paymentMeansId;
    newCart.minimumPaymentAmount = obj.minimumPaymentAmount;
    newCart.closeDialog = obj.closeDialog;
    newCart.minRepay = obj.minRepay;
    return newCart;
  }

  public toJsonCart (): string {
    const json = {
      id: this.id,
      commandId: this.commandId,
      paymentReference: this.paymentReference,
      subscription: this.subscription,
      cartItems: this.cartItems,
      selectedTtc: this.selectedTtc,
      selectedLetterTtc: this.selectedLetterTtc,
      hasWaitingItems: this.hasWaitingItems,
      owner: this.owner,
      ownerType: this.ownerType,
      ownerId: this.ownerId,
      ownerLabel: this.ownerLabel,
      verify: this.verify,
      fromPaie: this.fromPaie,
      paymentMeansType: this.paymentMeansType,
      paymentMeansId: this.paymentMeansId,
      minimumPaymentAmount: this.minimumPaymentAmount,
      closeDialog: this.closeDialog,
      minRepay: this.minRepay,
    }
    return JSON.stringify(json);
  }

  public fromCart (obj: Cart): void {
    this.id = obj.id;
    this.commandId = obj.commandId;
    this.paymentReference = obj.paymentReference;
    this.subscription = obj.subscription;
    this.cartItems = obj.cartItems;
    this.selectedTtc = obj.selectedTtc;
    this.selectedLetterTtc = obj.selectedLetterTtc;
    this.hasWaitingItems = obj.hasWaitingItems;
    this.owner = obj.owner;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
    this.verify = obj.verify;
    this.fromPaie = obj.fromPaie;
    this.paymentMeansType = obj.paymentMeansType;
    this.paymentMeansId = obj.paymentMeansId;
    this.minimumPaymentAmount = obj.minimumPaymentAmount;
    this.closeDialog = obj.closeDialog;
    this.minRepay = obj.minRepay;
  }

  public compareCart (value: Cart): boolean {
    return (this.toJsonCart() == value.toJsonCart());
  }

  public cloneCart (): Cart {
    return Cart.fromJson(this);
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static command (cart: Cart): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/command', cart, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Cart.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getCart (owner: Owner): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/getCart', owner, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Cart.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static repay (cart: Cart): Promise<Cart> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/carts/repay', cart, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Cart.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(carts: Cart[]) {
  }
}
